import { Components, Theme } from '@mui/material/styles';

export const muiTooltipOverride: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.vars.palette.grey[700],
      fontWeight: 400,
      padding: theme.spacing(4),
      fontSize: 10,
    }),
    tooltipArrow: ({ theme }) => ({
      backgroundColor: theme.vars.palette.grey[700],
    }),
  },
  defaultProps: {
    arrow: true,
  },
};
